/* LOOM Brand Designs - Vitadermis Welcome Popup v1.2 */
(function () {
  var pop = document.getElementById('vd-pop');
  var teaser = document.getElementById('vd-teaser');
  if (!pop || !teaser) return;
  var C = window.VD_POPUP_CFG || {};
  var KEY = 'vd_welcome_popup_v1';
  var email = '';
  var shown = false;

  function rd() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function wr(p) { try { var c = rd(); for (var k in p) c[k] = p[k]; localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {} }
  function blocked() {
    var st = rd(), now = Date.now();
    if (st.signedUpAt && now - st.signedUpAt < C.signupDays * 864e5) return true;
    if (st.dismissedAt && now - st.dismissedAt < C.dismissDays * 864e5) return true;
    return false;
  }

  /* Wait only while a consent DIALOG is actually open. The consent app also
     leaves a permanent bottom-left reopen widget after the visitor answers;
     that must NOT count as blocking or the popup would never appear again. */
  function cmpBlocking() {
    var hosts = document.querySelectorAll('pandectes-cmp, #shopify-pc__banner, [id*="pandectes"]');
    for (var h = 0; h < hosts.length; h++) {
      var root = hosts[h].shadowRoot || hosts[h];
      if (!root.querySelectorAll) continue;
      var dlgs = root.querySelectorAll('dialog');
      for (var i = 0; i < dlgs.length; i++) {
        var d = dlgs[i], r = d.getBoundingClientRect();
        if (d.open && r.width > 40 && r.height > 40) return true;
      }
    }
    return false;
  }

  function open() {
    if (pop.getAttribute('data-open') === '1') return;
    pop.setAttribute('data-open', '1');
    teaser.setAttribute('data-open', '0');
    shown = true;
    document.body.style.overflow = 'hidden';
    var f = pop.querySelector('.vd-step-email input');
    if (f) setTimeout(function () { f.focus(); }, 120);
  }
  var waits = 0;
  function tryOpen() {
    if (shown || blocked()) return;
    if (cmpBlocking()) {
      if (waits++ > 600) { tease(); return; }
      setTimeout(tryOpen, 1000);
      return;
    }
    open();
  }
  function tease() { if (pop.getAttribute('data-open') !== '1') teaser.setAttribute('data-open', '1'); }
  function close(mark) {
    pop.setAttribute('data-open', '0');
    document.body.style.overflow = '';
    if (mark) wr({ dismissedAt: Date.now() });
    tease();
  }
  function err(id, msg) {
    var el = document.getElementById(id);
    if (!el) return;
    el.textContent = msg || '';
    el.setAttribute('data-show', msg ? '1' : '0');
  }
    /* CAPTCHA is enabled on customer forms, so the signup must go through a real
     Shopify {% form 'customer' %}. requestSubmit() fires the submit event, which
     is what lets Shopify attach its CAPTCHA token. */
  function submitNative(tags) {
    var f = document.getElementById('vd-form');
    var t = document.getElementById('vd-tags');
    if (!f) return;
    if (t) t.value = tags;
    try { localStorage.setItem('vd_pending_tier', tags.indexOf('welcome-10') > -1 ? '10' : '5'); } catch (e) {}
    if (f.requestSubmit) { f.requestSubmit(); }
    else { var b = document.getElementById('vd-realsubmit'); if (b) b.click(); else f.submit(); }
  }
  function finish(tier) {
    document.getElementById('vd-code').textContent = tier === 10 ? C.code10 : C.code5;
    document.getElementById('vd-tier').textContent = tier === 10 ? C.tier10 : C.tier5;
    pop.setAttribute('data-step', 'done');
    wr({ signedUpAt: Date.now() });
    teaser.setAttribute('data-open', '0');
  }

    document.getElementById('vd-submit-email').addEventListener('click', function () {
    var v = (document.getElementById('vd-email').value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { err('vd-err-email', C.errEmail); return; }
    err('vd-err-email', '');
    email = v;
    pop.setAttribute('data-step', 'sms');
    var p = document.getElementById('vd-phone');
    if (p) setTimeout(function () { p.focus(); }, 120);
  });

    document.getElementById('vd-submit-phone').addEventListener('click', function () {
    var b = this, raw = (document.getElementById('vd-phone').value || '').replace(/[^\d]/g, '');
    if (raw.length < 6) { err('vd-err-phone', C.errPhone); return; }
    err('vd-err-phone', '');
    b.disabled = true;
    var e164 = String(C.prefix || '').replace(/[^\d+]/g, '') + raw.replace(/^0+/, '');
    document.getElementById('vd-phone').value = e164;
    submitNative(C.tagsBase + ',' + C.tags10);
  });

    document.getElementById('vd-skip-phone').addEventListener('click', function () {
    var p = document.getElementById('vd-phone');
    if (p) p.value = '';
    submitNative(C.tagsBase + ',' + C.tags5);
  });

  document.getElementById('vd-copy').addEventListener('click', function () {
    var b = this, code = document.getElementById('vd-code').textContent, lbl = b.textContent;
    function ok() { b.textContent = C.copied; setTimeout(function () { b.textContent = lbl; }, 1600); }
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(ok, ok); } else { ok(); }
  });

  Array.prototype.forEach.call(pop.querySelectorAll('[data-vd-close]'), function (el) {
    el.addEventListener('click', function () { close(pop.getAttribute('data-step') !== 'done'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pop.getAttribute('data-open') === '1') close(true);
  });
  teaser.addEventListener('click', open);

      if (document.getElementById('vd-posted')) {
    var tier = 5;
    try { tier = localStorage.getItem('vd_pending_tier') === '10' ? 10 : 5; localStorage.removeItem('vd_pending_tier'); } catch (e) {}

    var leadSent = false;
    try { leadSent = sessionStorage.getItem('vd_lead_sent') === '1'; } catch (e) {}
        if (!leadSent) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'vd_lead',
        lead_method: 'popup',
        lead_tier: String(tier),
        sms_optin: tier === 10 ? 'yes' : 'no'
      });
      try { sessionStorage.setItem('vd_lead_sent', '1'); } catch (e) {}
    }

    open();
    finish(tier);
    return;
  }

  if (blocked()) { tease(); return; }
  setTimeout(tryOpen, C.delay);
  var onScroll = function () {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && (window.scrollY / h) * 100 >= C.scrollPct) {
      window.removeEventListener('scroll', onScroll);
      tryOpen();
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  if (C.exitIntent && window.matchMedia('(min-width: 750px)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) tryOpen();
    });
  }
})();
